import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import HowWeWork from "./components/HowWeWork";
import OurSolutions from "./components/OurSolutions";
import WhoWeWorkWith from "./components/WhoWeWorkWith";
import FounderApproach from "./components/FounderApproach";
import PhoneShowcase from "./components/PhoneShowcase";
import CTASection from "./components/CTASection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import CursorGlow from "./components/CursorGlow";
import FloatingElements from "./components/FloatingElements";
import ScrollProgress from "./components/ScrollProgress";
import FloatingDiscoveryBox from "./components/FloatingDiscoveryBox";
import { Toaster } from "./components/ui/sonner";

// Service Pages
import MobileAppDevelopment from "./pages/services/MobileAppDevelopment";
import AiIntegration from "./pages/services/AiIntegration";
import WebDesign from "./pages/services/WebDesign";
import DigitalGrowth from "./pages/services/DigitalGrowth";
import MediaDistribution from "./pages/services/MediaDistribution";
import Ecommerce from "./pages/services/Ecommerce";
import SocialMediaService from "./pages/services/SocialMedia";

// General Pages
import About from "./pages/About";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import WebAnalysis from "./pages/WebAnalysis";
import Career from "./pages/Career";
import References from "./pages/References";
import PortfolioPage from "./pages/PortfolioPage";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import Team from "./pages/Team";
import ThankYou from "./pages/ThankYou";
import NotFound from "./pages/NotFound";
import FAQPage from "./pages/FAQ";
import Sitemap from "./pages/Sitemap";
import GetQuote from "./pages/GetQuote";
import JobDetail from "./pages/JobDetail";

// Portfolio Pages
import SocialMedia from "./pages/portfolio/SocialMedia";
import SEOPortfolio from "./pages/portfolio/SEO";
import WebPortfolio from "./pages/portfolio/Web";
import MobilePortfolio from "./pages/portfolio/Mobile";

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const Home = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const scrollTo = searchParams.get('scrollTo');
    if (scrollTo) {
      // Wait for page to render
      const scrollToSection = () => {
        const element = document.getElementById(scrollTo);
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      };
      
      // Try immediately and after a short delay
      setTimeout(scrollToSection, 100);
      setTimeout(scrollToSection, 500);
    }
  }, [searchParams]);

  return (
    <div className="bg-slate-900 min-h-screen relative">
      <CursorGlow />
      <FloatingElements />
      <ScrollProgress />
      <FloatingDiscoveryBox />
      <Header />
      <HeroSection />
      <HowWeWork />
      <OurSolutions />
      <WhoWeWorkWith />
      <FounderApproach />
      <PhoneShowcase />
      <CTASection />
      <ContactSection />
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Service Pages */}
          <Route path="/services/mobile-app-development" element={<MobileAppDevelopment />} />
          <Route path="/services/ai-integration" element={<AiIntegration />} />
          <Route path="/services/web-design" element={<WebDesign />} />
          <Route path="/services/digital-growth" element={<DigitalGrowth />} />
          <Route path="/services/media-distribution" element={<MediaDistribution />} />
          <Route path="/services/social-media" element={<SocialMediaService />} />
          <Route path="/services/ecommerce" element={<Ecommerce />} />
          {/* General Pages */}
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/sozlesmeler" element={<Legal />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/web-analiz" element={<WebAnalysis />} />
          <Route path="/kariyer" element={<Career />} />
          <Route path="/referanslar" element={<References />} />
          <Route path="/calismaalarimiz" element={<PortfolioPage />} />
          {/* Portfolio Pages */}
          <Route path="/portfolyo/sosyal-medya" element={<SocialMedia />} />
          <Route path="/portfolyo/seo" element={<SEOPortfolio />} />
          <Route path="/portfolyo/web" element={<WebPortfolio />} />
          <Route path="/portfolyo/mobil-uygulama" element={<MobilePortfolio />} />
          {/* New Pages */}
          <Route path="/hizmetler" element={<Services />} />
          <Route path="/fiyatlandirma" element={<Pricing />} />
          <Route path="/ekip" element={<Team />} />
          <Route path="/tesekkurler" element={<ThankYou />} />
          <Route path="/sss" element={<FAQPage />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/teklif-al" element={<GetQuote />} />
          <Route path="/kariyer/:slug" element={<JobDetail />} />
          {/* 404 - Must be last */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
